import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Recipient } from 'src/app/models/recipients.model';
import { User } from 'src/app/models/user.model';

@Component({
    selector: 'que-contact-circle',
    imports: [CommonModule],
    templateUrl: './contact-circle.component.html',
    styleUrls: ['./contact-circle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactCircleComponent {
  @Input()
  user?: User

  @Input() displayTooltip = false;
  @Input() isCreator = false;

}
